<template>
  <div class="reload-or-home">
    <v-img :src="require('@/assets/403-image.jpeg')" contain height="254" style="filter: grayscale(1); opacity: 0.7;" />
    <h1>OOPA!!</h1>
    <v-alert dense text prominent border="left" style="text-align: left;" class="mx-2">
      Parece que perdemos a conexão com o seu celular ou então seu acesso expirou. <b>Tente recarregar ou faça login novamente.</b>
    </v-alert>
    <v-btn
      @click="reloadPage"
      color="primary"
      :elevation="0"
      class="mb-6 mt-3"
      large
      outlined
      style="height: 100px; width: 100%;"
    >
      <v-icon class="pr-3" size="20px">mdi-cached</v-icon> Recarregar
    </v-btn>
    <v-btn
      @click="logout"
      color="red"
      :elevation="0"
      outlined
      large
    >
      <v-icon class="pr-3" size="20px">mdi-account-key</v-icon> Fazer login
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'Forbidden',
  methods: {
    reloadPage() {
      window.location.href = '/';
    },
    logout() {
      this.$store.dispatch('Auth/logout');
      this.$router.push('/login');
    }
  }
}
</script>

<style lang="scss" scoped>
.reload-or-home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
}

.reload-or-home h1 {
  margin-bottom: 20px;
}
</style>
